// src/config/customMaterial.js — Request Custom Material.
// The amount charged is set on the server (functions/customMaterial.js,
// CUSTOM_MATERIAL_CENTS). Keep this label in step with it.

export const CUSTOM_MATERIAL_PRICE = 29;
export const CUSTOM_MATERIAL_PRICE_LABEL = "$29";

export const SONG_STYLES = ["Any Style", "Light Rock", "Hip Hop", "Country", "Latin", "R&B", "Pop", "Kids Pop"];

// what the home page demo opens with, so visitors see a filled-in form
export const DEMO_REQUEST = {
  topic: "The Water Cycle",
  subject: "science",
  grade: "3rd",
  state: "va",
  style: "Hip Hop",
  facts: [
    "The sun heats water and it turns into vapor — that's evaporation.",
    "Water vapor cools into clouds — that's condensation.",
    "Water falls as rain, snow, sleet or hail — that's precipitation.",
    "Water collects in oceans, lakes and rivers — that's collection.",
  ],
  questions: [
    { question: "What is it called when water turns into vapor?", answer: "Evaporation", wrong: ["Condensation", "Collection", ""] },
    { question: "Clouds form during which step?", answer: "Condensation", wrong: ["Precipitation", "Evaporation", ""] },
  ],
  pairs: [
    { left: "Evaporation", right: "Water turns into vapor" },
    { left: "Precipitation", right: "Rain, snow, sleet or hail" },
  ],
  notes: "Our class is visual learners — please keep the words simple.",
};
